import React, { Suspense, useEffect, useContext } from "react";
import "./App.css";
import routes from "./routes";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import useLoading from "./component/loadingComponent/UseLoading";
import useLoadingProgress from "./component/loadingComponent/useLoadingProgress";
import LoadingAnimation from "./component/loadingComponent/LoadingAnimation";
import { SiteUnitProvider } from "./context/SiteUnitContext";
import AuthContext from "./services/auth/AuthContext";
import ErrorBoundary from "./component/ErrorBoundary";
import { initializeErrorHandling } from "./utils/errorHandler";
import "./utils/errorOverlaySuppress";
import "./utils/webpackErrorSuppress";

function App() {
  const loading = useLoading(1500); // shorter fallback delay
  const { progress, loading: progressLoading } = useLoadingProgress(1500);
  const location = useLocation();
  const { user, loading: authLoading } = useContext(AuthContext);
  const authenticatedUserKey = user?.id || user?.user_id || user?.email || null;

  // Initialize error handling on app mount
  useEffect(() => {
    initializeErrorHandling({
      suppressInProduction: true,      // Hide errors in production
      suppressConsoleErrors: true,     // Filter console errors
      suppressGlobalErrors: true       // Suppress uncaught errors
    });
  }, []);

  return (
    <ErrorBoundary showError={false}>
      <div className="App">
        {(authLoading || loading || progressLoading) ? (
          <LoadingAnimation progress={progress} />
        ) : (
          <SiteUnitProvider
              key={authenticatedUserKey || "guest"}
              userKey={authenticatedUserKey}
            >
            <Suspense fallback={<LoadingAnimation />}>
              <AnimatePresence mode="wait">
                <Routes location={location} key={location.key}>
                  {routes.map((route, index) => (
                    <Route
                      key={location.key + index} // Use location key combined with index
                      path={route.path}
                      element={
                        <ErrorBoundary showError={false}>
                          {route.element}
                        </ErrorBoundary>
                      }
                    />
                  ))}
                </Routes>
              </AnimatePresence>
            </Suspense>
          </SiteUnitProvider>
        )}
      </div>
    </ErrorBoundary>
  );
  
}

export default App;
